import { ApiRequestError } from './bccampusGraphQLRequest';


// interface RequestArgs {
//     url: string;
//     method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
//     body?: any; // Anything json serializable
//     args?: RequestInit;
// }
export async function RestApiRequest({ url, method, body, args }) {
  try {
    const request_body = body ? JSON.stringify(body) : args?.body;
    const headers = args && args.headers ? { ...args.headers } : {};
    headers['Content-Type'] = "application/json";
    const response = await fetch(url, {
      ...args,
      headers,
      method: method ?? args?.method ?? 'GET',
      body: request_body
    });
    if (!response.ok) throw new ApiRequestError(response.status, "Error in HTTP API Request");
    const response_body = await response.json();
    return response_body;
  }
  catch (error) {
    console.error("[RestApiRequest] Error", error);
    if (error instanceof ApiRequestError) throw error;
    else throw new ApiRequestError(500, "Error in HTTP Request");
  }
}

const apiServer = process.env.REACT_APP_OOC_RESTAPI_ENDPOINT;
const base_url = apiServer ? apiServer + "/api" : "";

export default function RepoApiRequest({ url, method, body, args }) {
  return RestApiRequest({
    url: `${base_url}${url}`,
    method,
    body,
    args
  });
}
